import { useState } from "react";
import { apiSend, errorMessage } from "./api";
import "./Login.css";

function Login({ onLogin, onBack }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await apiSend("/api/login", "POST", { email, password }, "Erreur de connexion");
      onLogin(user);
      return;
    } catch (err) {
      setError(errorMessage(err, "Erreur de connexion"));
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1>Racines</h1>
        <p className="login-subtitle">Connectez-vous à votre compte</p>
        {error && <div className="login-error">{error}</div>}
        <label>Email</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <label>Mot de passe</label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Connexion..." : "Se connecter"}
        </button>
        {/* Sans ça, l'écran de connexion est un cul-de-sac : seul un F5 en sort */}
        {onBack && (
          <button type="button" className="login-back" onClick={onBack}>
            Retour à l'accueil
          </button>
        )}
      </form>
    </div>
  );
}

export default Login;
